<template>
  <div class="warning">
    <div class="tabs">
      <button
        :class="{ active: activeIndex === 1 }"
        @click="
          () => {
            activeIndex = 1
            $nextTick(() => {
              echart.resize()
            })
          }
        "
      >
        地图
      </button>
      <button :class="{ active: activeIndex === 0 }" @click="activeIndex = 0">
        列表
      </button>
    </div>
    <div class="content">
      <div class="list" v-show="activeIndex === 0">
        <div class="warning-images">
          <div class="first"></div>
          <div class="item" v-for="item in alarmIcon" :key="item">
            <img :src="require('@/assets/images/alarmicon/' + item + '.gif')" />
          </div>
          <div class="item" v-for="index in entryLenght" :key="index"></div>
        </div>
        <div class="warning-info">
          <div class="area" v-for="item in areas" :key="item">
            <div class="first">{{ item.slice(0, 2) }}</div>
            <div
              class="item"
              v-show="item1"
              :style="{ background: item1 }"
              v-for="(item1, index) in alarnArea[item]"
              :key="index"
            ></div>
          </div>
        </div>
      </div>
      <div class="map" v-show="activeIndex === 1">
        <div class="warning-images">
          <div class="item" v-for="(item, index) in alarmIcon" :key="item" @click="getColor(index)">
            <img
              :src="require('@/assets/images/alarmicon/' + item + '.gif')"
              :class="{ active: index === activeIconIndex }"
            />
          </div>
        </div>
        <div class="echart-wrap">
          <div id="echart"></div>
        </div>
        <div class="alarm-right-tip">
          <div class="alarn-item" v-for="item in rightAlarnColor" :key="item.name">
            <span :style="{ background: item.sigcolor }"></span>
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from '@/config/echarts/index.js'
import { jsonData, apiData } from '../../api/index'
export default {
  data () {
    return {
      areas: ['禅城区', '南海区', '顺德区', '三水区', '高明区'],
      activeIndex: 1,
      activeIconIndex: 0,
      echart: '',
      entryLenght: 0,
      alarmIcon: [],
      alarnArea: {},
      WarningAreaColor: [],
      rightAlarnColor: [],
      countyAlarm: []
    }
  },
  created () {
    this.getCountyAlarm()
  },
  mounted () {
    // this.loadEchart()
    window.addEventListener('resize', () => {
      if (this.echart !== '') {
        this.echart.resize()
      }
    })
  },
  methods: {
    /**
     * 加载图表
     */
    async loadEchart () {
      if (this.echart === '') {
        const res = await jsonData.getFsMap()
        this.echart = echarts.init(document.getElementById('echart'))
        echarts.registerMap('gzMap', res)
      }
      const option = {
        geo: {
          itemStyle: {
            normal: {
              label: { show: true, textStyle: { color: '#000' } },
              borderColor: '#8CAFBB',
              borderWidth: 1.0,
              areaColor: '#1F2C49'
            }
          },
          emphasis: {
            label: { show: true, textStyle: { color: '#000000' } },
            itemStyle: {
              areaColor: '#E8F6FC',
              shadowColor: 'rgba(0, 0, 0, 0.7)',
              shadowOffsetX: -2,
              shadowOffsetY: 2,
              shadowBlur: 10
            }
          },
          type: 'map',
          map: 'gzMap', // chinaMap需要和registerMap中的第一个参数保持一致
          roam: true, // 设置允许缩放以及拖动的效果
          aspectScale: 1,
          // label: {
          //   show: true // 展示标签
          // },
          zoom: 1.2, // 设置初始化的缩放比例
          regions: this.WarningAreaColor
        },
        series: [
          {
            type: 'map',
            map: '佛山',
            geoIndex: 0,
            data: this.WarningAreaColor
          }
        ]
      }
      this.echart.setOption(option)
    },
    /**
     * 正在生效的区县预警信号
     */
    async getCountyAlarm () {
      const countyAlarm = []
      const result = await apiData.countyAlarm()
      this.areas.forEach(item => {
        const arr = result[item] ? result[item] : []
        countyAlarm.push(...arr)
      })
      countyAlarm.forEach(item => {
        const alarnIcon = item.signame + item.siglevel
        const index = this.alarmIcon.findIndex(iten => iten.includes(item.signame))
        if (index < 0) {
          this.alarmIcon.push(alarnIcon)
        } else {
          const num = Number(this.alarmIcon[index].split('')[1])
          if (item.siglevel > num) {
            this.alarmIcon[index] = alarnIcon
          }
        }
      })

      this.countyAlarm = countyAlarm
      console.log(countyAlarm, this.alarmIcon)
      this.areas.forEach(area => {
        this.alarnArea[area] = []
        for (let i = 0; i < 4; i++) {
          const item = countyAlarm.find(
            item => this.alarmIcon[i] && this.alarmIcon[i].includes(item.signame) && item.county === area
          )
          if (item) {
            this.alarnArea[area].push(item.sigcolor)
          } else {
            this.alarnArea[area].push('#33446A')
          }
        }
      })

      this.entryLenght = 4 - this.alarmIcon.length
      this.getColor(0)
    },

    getColor (index) {
      this.activeIconIndex = index
      const WarningAreaColor = []
      this.rightAlarnColor = []
      const signame = this.alarmIcon[index]
      this.areas.forEach((street, index) => {
        let color = '#33446A'
        this.countyAlarm.forEach(alarm => {
          if (alarm.county === street && signame.includes(alarm.signame)) {
            color = alarm.sigcolor
            const areaData = {
              name: street,
              aname: alarm.aname,
              ddatetime: alarm.ddatetime,
              sigcolor: alarm.sigcolor,
              // content: this.getAlarmContent(alarm.aname),
              itemStyle: {
                areaColor: alarm.sigcolor
              },
              emphasis: { itemStyle: { areaColor: alarm.sigcolor } }
            }
            WarningAreaColor.push(areaData)
          }
        })
        this.rightAlarnColor.push({ name: street.slice(0, 2), sigcolor: color })
      })
      this.WarningAreaColor = WarningAreaColor
      this.loadEchart()
    }
  }
}
</script>
<style lang="less" scoped>
.warning {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  .tabs {
    z-index: 99;
    button {
      width: 5.13rem;
      height: 2.19rem;
      background: #0c4170;
      border-radius: 0.5rem;
      border: 0;
      font-size: 0.88rem;
      font-weight: 600;
      color: #fff;
      margin-right: 0.63rem;
      cursor: pointer;
    }
    button.active {
      background: linear-gradient(180deg, #2d74f5 0%, #53a5fa 100%);
    }
  }
  .content {
    flex: 1;
    .list {
      position: absolute;
      left: 0;
      right: 0;
      top: 2rem;
      bottom: 0;
      display: flex;
      flex-direction: column;
      .warning-images {
        display: flex;
        justify-content: space-between;
        margin: 2rem 0 0.5rem;
        .item {
          height: 2.5rem;
          background: transparent;
          text-align: center;
          img {
            margin: 0 auto;
          }
        }
      }
      .warning-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .area {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
      .first {
        font-size: 0.88rem;
        color: #fff;
        min-width: 1.875rem;
      }
      .item {
        display: flex;
        width: 7.23rem;
        height: 0.7rem;
        background: #e9edf3;
        border-radius: 0.38rem;
      }
    }
    .map {
      display: flex;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      .warning-images {
        margin-top: 4.56rem;
        .item {
          margin-bottom: 0.5rem;
          img {
            width: 3.51rem;
            &:hover {
              cursor: pointer;
            }
          }
          .active {
            border: 2px solid #00ddff;
          }
        }
      }
      .echart-wrap {
        flex: 1;
        position: relative;
        #echart {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
        }
      }
      .alarm-right-tip {
        position: absolute;
        right: 0px;
        bottom: 0px;
        top: 0px;
        display: flex;
        flex-direction: column;
        .alarn-item {
          flex: 1;
          span {
            font-size: 0.73vw;
            font-weight: 400;
            color: #fff;
          }
          span:nth-child(1) {
            display: inline-block;
            margin-right: 0.52vw;
            width: 1.61vw;
            height: 0.78vw;
            border-radius: 0.31vw;
          }
        }
      }
    }
  }
}
</style>
